// extracted by mini-css-extract-plugin
module.exports = {"fi_text":"index-module__fi_text___LslFP","featured_in":"index-module__featured_in___0HDkq","img":"index-module__img___3Qk8E"};